import React from 'react';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { brandColors, ENCYCDATA_URL } from '@config/brandTokens';

interface SiteFooterProps {
  compact?: boolean;
}

const FOOTER_LINKS = [
  { label: 'Motor & Psychomotor', to: '/motor-psychomotor' },
  { label: 'Fitness Standards', to: '/fitness-standards' },
  { label: 'Blogs', to: '/blogs' },
  { label: 'Careers', to: '/careers' },
  { label: 'Support', to: '/support' },
] as const;

/** Shared site footer — Encycdata attribution only here, not in header. */
const SiteFooter: React.FC<SiteFooterProps> = ({ compact = false }) => {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: brandColors.navy,
        color: '#cbd5e1',
        py: compact ? 1.5 : 2,
        mt: 'auto',
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: 1440,
          px: { xs: 2.5, md: 4 },
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: 1.25,
        }}
      >
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 500, color: '#e2e8f0' }}>
            EncycGames is an initiative from{' '}
            <Link
              href={ENCYCDATA_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: brandColors.blue,
                fontWeight: 600,
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              Encycdata
            </Link>
          </Typography>
          {!compact && (
            <Stack direction="row" spacing={1.5} useFlexGap flexWrap="wrap" sx={{ mt: 0.75 }}>
              {FOOTER_LINKS.map((item) => (
                <Link
                  key={item.to}
                  component={RouterLink}
                  to={item.to}
                  underline="hover"
                  sx={{ color: '#94a3b8', fontSize: '0.9rem', fontWeight: 600 }}
                >
                  {item.label}
                </Link>
              ))}
            </Stack>
          )}
        </Box>
        <Typography variant="caption" sx={{ color: '#94a3b8' }}>
          © {year} · Sports knowledge platform
        </Typography>
      </Container>
    </Box>
  );
};

export default SiteFooter;
